import { render, staticRenderFns } from "./CreateOrganization.vue?vue&type=template&id=53cc22be&scoped=true"
import script from "./CreateOrganization.vue?vue&type=script&lang=js"
export * from "./CreateOrganization.vue?vue&type=script&lang=js"
import style0 from "./CreateOrganization.vue?vue&type=style&index=0&id=53cc22be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cc22be",
  null
  
)

export default component.exports